import axios from 'axios'
import T from '../../translate/T'

let language = T.getLanguage()

export const is_logged = (data) => {
    return {
        type: 'USER_LOGGED',
        payload: data,
        location: {
            latitude: '',
            longitude: ''
        }
    }
}

export const logout = () => {
    return dispatch => {
        axios.get('sign/out')
        
        setTimeout(() => {
            localStorage.removeItem('authorization')
            sessionStorage.removeItem('authorization')
        }, 500)

        dispatch({
            type: 'USER_LOGOFF'
        })
        dispatch({
            type: 'USER_NOTIFICATION_CLEAR'
        })
    }
}

export const is_out = () => {
    return {
        type: 'USER_LOGOFF',
        payload: ''
    }
}

export const updateAuthorization = (auth) => {
    return {
        type: 'AUTH_UPDATED',
        payload: auth
    }
}

export const updateUserData = (userData) => {
    return {
        type: 'USER_UPDATED',
        payload: userData
    }
}

export const setStatus = (status, message = null) => {
    return {
        type: 'LOGIN_CHANGED_STATUS',
        payload: {
            status,
            message
        }
    }
}

export const modalIsOpen = test => {
    return {
        type: 'LOGIN_CHANGED_MODAL_OPEN',
        payload: test
    }
}

export const login = (data, save) => {
    return dispatch => {
        if(!data.username || data.username === '') {
            dispatch({
                type: 'LOGIN_CHANGED_STATUS',
                payload: {
                    status: 'error',
                    message: T.txt('fill_username')
                }
            })
            return
        }

        if(!data.password || data.password === '') {
            dispatch({
                type: 'LOGIN_CHANGED_STATUS',
                payload: {
                    status: 'error',
                    message: T.txt('fill_password')
                }
            })
            return
        }

        dispatch(setStatus('loading'))
        axios.post('sign/in', data)
            .then(response => {
                if(response.errors) {
                    dispatch(setStatus('error', response.errors[0].message))          
                }else{
                    if(save) {
                        localStorage.setItem('authorization', response.authorization)
                    } else {
                        sessionStorage.setItem('authorization', response.authorization)
                    }

                    
                    dispatch(changeLanguage(response.user.language))
                    
                    dispatch(is_logged(response))
                    dispatch(setStatus('done'))
                }
            })
    }
}

export const logon = () => {
    return dispatch => {
        let authorization = localStorage.getItem('authorization') || sessionStorage.getItem('authorization') || ''
        
        dispatch(updateAuthorization(authorization))
        

        dispatch({
            type: 'LOGIN_LOGON_STATUS',
            payload: 'loading'
        })

        axios.post('sign/user_data')
           .then(response => {
               
                if(response.errors) {
                    dispatch(is_out())
                } else{
                    dispatch(changeLanguage(response.language))
                    
                    dispatch(updateUserData(response))
                }
                dispatch({
                    type: 'LOGIN_LOGON_STATUS',
                    payload: 'done'
                })
                
           })
   }
}


export const loginSocial = (type, data, save) => {
    return dispatch => {

        axios.post('sign/'+type, data)
            .then(response => {
                if(save) {
                    localStorage.setItem('authorization', response.authorization)
                } else {
                    sessionStorage.setItem('authorization', response.authorization)
                }
                
                dispatch(changeLanguage(response.language))

                dispatch(is_logged(response))
                dispatch(setStatus('done'))
            })
    }
}

export const changeLanguage = (lang) => {
    lang = lang || language
    lang = T.setLanguage(lang)
    
    return (dispatch, getState) => {
        // let store = getState()

        // if(lang !== language) 
        
        // language = lang

        // if(store.login.isLogged) {
        //     axios.post(`users/update_language`, {
        //         language
        //     })
        // }

        dispatch({
            type: 'LANGUAGE',
            payload: lang
        })
    }
}


// WEBPACK FOOTER //
// ./src/modules/actions/Login.js